window.intakesModule = angular.module('intakesModule', [])

const context = require.context(".", true, /\.coffee$/);
context.keys().forEach(function (key) {
    context(key);
});